import appConfig from "@/app.config";

window['$'] = window['$'] || {};
if (typeof window['$'].get !== 'function') {
    window['$'].get = (url, cb) => {
        url = url.replace(/&amp;/g, '&');
        return this.http
            .get(url, { responseType: 'text' })
            .toPromise()
            .then(cb);
    };
}

export default {
    push(obj) {
        window['dataLayer'].push(obj);
    },

	pageView(quizPath) {
		this.push({
			event: 'virtualPageview',
			app_name: appConfig.appName,
			platform: appConfig.platform,
			quizPath
		});
	}    
}